import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useLocation, useParams } from "react-router-dom";
import OtpInput from "react-otp-input";
import Language from "../Card/Lang";
import { produrl, textMapping } from "../utils/helper";
import ErrorPopup from "../Popup/ErrorPopup";
const CryptoJS = require("crypto-js");

const Otp = () => {
  const [otp, setOtp] = useState("");
  const [num, setNum] = useState("");
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [langSelect, setLangSelect] = useState("en");
  const [errorpopup, setErrorpopup] = useState(false);
  const [message, setMessage] = useState("");
  const [remainmessage, setRemainMessage] = useState(false);
  const [timer, setTimer] = useState(40);
  const [isResendEnabled, setIsResendEnabled] = useState(true);
  const [intervalId, setIntervalId] = useState(null);
  const [freshlang, setFreshlang] = useState("");
  const [remainingOtp, setRemainingOtp] = useState("");
  const [ip, setIp] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const { refnum } = useParams();

  const { userotp } = location.state || {};
  const decryptData = (encryptedData, secretKey) => {
    try {
      if (!encryptedData) return null;
      const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      return decryptedData ? JSON.parse(decryptedData) : null;
    } catch (error) {
      console.error("Error during decryption or parsing:", error);
      return null;
    }
  };

  useEffect(() => {
    fetchGoogleIP();
  }, []);

  const fetchGoogleIP = async () => {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      const data = await response.json();
      setIp(data.ip);
    } catch (error) {
      console.error("Error fetching IP:", error);
      setIp("Error fetching IP");
    }
  };

  useEffect(() => {
    const localnum = localStorage.getItem("num");
    setNum(localnum);

    if (localStorage.getItem("language")) {
      setLangSelect(localStorage.getItem("language"));
    } else {
      localStorage.setItem("language", langSelect);
    }

    // Start the timer when the component mounts
    startTimer();

    // Cleanup on component unmount
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [langSelect]);

  const startTimer = () => {
    // Clear existing interval if any
    if (intervalId) {
      clearInterval(intervalId);
    }

    // Start a new timer
    const id = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(id);
          if (remainingOtp !== 1) {
            // Only enable resend if remaining attempts are not 1
            setIsResendEnabled(true);
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    setIntervalId(id); // Store interval ID
  };

  const handleOtpChange = (value) => {
    setOtp(value);
    setIsButtonEnabled(value.length === 6);
  };

  const Backnumber = () => {
    navigate("/" + window.location.search);
  };

  const handleResendOtp = async () => {
    if (!isResendEnabled) return;
    // Reset timer and disable resend button
    setTimer(40);
    setIsResendEnabled(false);
    startTimer();
    const url = `${produrl}api/v1/otp/resend`;

    let headers = [
      ["Content-Type", "application/json"],
      [
        "Akamai-BM-Telemetry",
        window.bmak && window.bmak.get_telemetry
          ? window.bmak.get_telemetry()
          : "",
      ],
    ];
    if (window.location.href.indexOf("appversion") != -1) {
      headers.push([
        "Custom-Header",
        "8a8a4871be43ad546a88af7f769cf672b665a13e46d90bf20f29916f92a617",
      ]);
    }
    const options = {
      method: "POST",
      headers: new Headers(headers),
      body: JSON.stringify({
        otp_token: userotp ? userotp : localStorage.getItem("userotpkonen"),
      }),
    };
    //error handling akamai
    const controller = new AbortController();
    const { signal } = controller;
    const timeoutId = setTimeout(() => controller.abort(), 5000);
    //error handling akamai

    try {
      // const response = await fetch(url, options);
      const response = await fetch(url, { ...options, signal });
      const customHeaderValue = response.headers.get("content-type");

      if (response.ok) {
        const data = await response.json();
        try {
          let obj = {};
          window.gtag("event", `Resend Otp Successfully`, obj);
        } catch (error) {}

        if (data.remaining_otp_attempts) {
          setRemainingOtp(data.remaining_otp_attempts);

          // Show the message for the remaining attempts
          setRemainMessage(true);

          if (data.remaining_otp_attempts === 1) {
            setIsResendEnabled(false);
            setTimer(0);
          }

          // Reset timer for the message display
          const timer = setTimeout(() => {
            setRemainMessage(false);
          }, 3000); // 3 seconds

          return () => clearTimeout(timer);
        }
      } else {
        //error handling akamai
        let errorText = await response.text();
        const decodedText = new DOMParser().parseFromString(
          errorText,
          "text/html"
        ).documentElement.textContent;
        const referenceMatch = decodedText.match(
          /#\d+\.[a-f0-9]+\.\d+\.[a-f0-9]+/i
        );
        ///Reference #(\d+\.\d+\.\d+\.\w+)/
        const referenceNumber = referenceMatch ? referenceMatch[0] : "";

        if (response.status == 502) {
          setErrorpopup(true);
          setMessage("502: Server Error");
        } else if (
          response.status == 403 &&
          customHeaderValue?.includes("text/html")
        ) {
          setErrorpopup(true);
          setMessage(
            textMapping(
              "Suspicious activity detected!! Access Denied " + referenceNumber
            )
          );
        } else if (response.status == 403) {
          let errorjson = JSON.parse(errorText);
          setErrorpopup(true);
          setMessage(textMapping(errorjson.message));
        } else if (response.status == 400) {
          let errorjson = JSON.parse(errorText);
          setErrorpopup(true);
          setMessage(textMapping(errorjson.message));
        } else {
          setErrorpopup(true);
          setMessage(textMapping("Error Occur"));
        }
        //error handling akamai
      }
      // if (response.status == 200) {
      //   try {
      //     let obj = {};
      //     window.gtag("event", `Resend Otp Successfully`, obj);
      //   } catch (error) {}

      //   if (data.remaining_otp_attempts) {
      //     setRemainingOtp(data.remaining_otp_attempts);

      //     // Show the message for the remaining attempts
      //     setRemainMessage(true);

      //     if (data.remaining_otp_attempts === 1) {
      //       setIsResendEnabled(false);
      //       setTimer(0);
      //     }

      //     // Reset timer for the message display
      //     const timer = setTimeout(() => {
      //       setRemainMessage(false);
      //     }, 3000); // 3 seconds

      //     return () => clearTimeout(timer);
      //   }
      // } else if (response.status == 403) {
      //   setErrorpopup(true);
      //   setMessage("Access Denied. Please try again");
      // } else {
      //   setErrorpopup(true);
      //   setMessage(
      //     textMapping("OTP limit reached for today. Please try again tomorrow")
      //   );
      // }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [intervalId]);

  const setLanguval = (lang) => {
    setFreshlang(lang);
  };

  // Format timer for display
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  const handleotp = async () => {
    const url = `${produrl}api/v1/otp/verify`;
    const form = new FormData();
    let headers = [
      ["Content-Type", "application/json"],
      [
        "Akamai-BM-Telemetry",
        window.bmak && window.bmak.get_telemetry
          ? window.bmak.get_telemetry()
          : "",
      ],
    ];
    if (window.location.href.indexOf("appversion") != -1) {
      headers.push([
        "Custom-Header",
        "8a8a4871be43ad546a88af7f769cf672b665a13e46d90bf20f29916f92a617",
      ]);
    }
    const options = {
      method: "POST",
      headers: new Headers(headers),
      body: JSON.stringify({
        otp_token: userotp ? userotp : localStorage.getItem("userotpkonen"),
        otp: otp,
      }),
    };
    // const options = {
    //   method: "POST",
    //   headers: [
    //     ["Content-Type", "application/json"],
    //     [
    //       "Akamai-BM-Telemetry",
    //       window.bmak && window.bmak.get_telemetry
    //         ? window.bmak.get_telemetry()
    //         : "",
    //     ],
    //     [
    //       "Custom-Header",
    //       "8a8a4871be43ad546a88af7f769cf672b665a13e46d90bf20f29916f92a617",
    //     ],
    //   ],
    //   body: JSON.stringify({
    //     otp_token: userotp ? userotp : localStorage.getItem("userotpkonen"),
    //     otp: otp,
    //   }),
    // };
    //error handling akamai
    const controller = new AbortController();
    const { signal } = controller;
    const timeoutId = setTimeout(() => controller.abort(), 5000);
    //error handling akamai
    try {
      // const response = await fetch(url, options);
      const response = await fetch(url, { ...options, signal });
      console.log("response otp", response);
      const customHeaderValue = response.headers.get("content-type");

      if (response.ok) {
        const data = await response.json();
        try {
          let obj = {};
          window.gtag("event", `Send Otp Successfully`, obj);
        } catch (error) {}
        if (data) {
          const oldAccessToken = localStorage.getItem("acesss");
          if (oldAccessToken) {
            localStorage.setItem("accessTokenPrevious", oldAccessToken);
          }
          if (oldAccessToken != data.token.access_token) {
            localStorage.removeItem("acesss");
            localStorage.removeItem("canvasimage");
          }
          localStorage.setItem("acesss", data.token.access_token);
          localStorage.setItem("refresh", data.token.refresh_token);
          localStorage.setItem("tokenSetTime", new Date().toISOString());

          if (data.token.aasm_state == "complete") {
            if (refnum) {
              navigate("/refer/" + refnum + window.location.search);
            } else {
              navigate("/refer/" + window.location.search);
            }
          } else {
            if (refnum) {
              navigate("/home/" + refnum + window.location.search);
            } else {
              navigate("/home/" + window.location.search);
            }
          }
        }
      } else {
        //error handling akamai
        let errorText = await response.text();
        const decodedText = new DOMParser().parseFromString(
          errorText,
          "text/html"
        ).documentElement.textContent;
        const referenceMatch = decodedText.match(
          /#\d+\.[a-f0-9]+\.\d+\.[a-f0-9]+/i
        );
        ///Reference #(\d+\.\d+\.\d+\.\w+)/
        const referenceNumber = referenceMatch ? referenceMatch[0] : "";

        if (response.status == 502) {
          setErrorpopup(true);
          setMessage("502: Server Error");
        } else if (
          response.status == 403 &&
          customHeaderValue?.includes("text/html")
        ) {
          setErrorpopup(true);
          setMessage(
            textMapping(
              "Suspicious activity detected!! Access Denied " + referenceNumber
            )
          );
        } else if (response.status == 403) {
          let errorjson = JSON.parse(errorText);
          setErrorpopup(true);
          setMessage(textMapping(errorjson.message));
        } else if (response.status == 400) {
          let errorjson = JSON.parse(errorText);
          setErrorpopup(true);
          setMessage(textMapping(errorjson.message));
        } else {
          setErrorpopup(true);
          setMessage(textMapping("Error Occur"));
        }
        //error handling akamai
      }
      // if (response.status == 200) {
      //   try {
      //     let obj = {};
      //     window.gtag("event", `Send Otp Successfully`, obj);
      //   } catch (error) {}
      //   if (data) {
      //     const oldAccessToken = localStorage.getItem("acesss");
      //     if (oldAccessToken) {
      //       localStorage.setItem("accessTokenPrevious", oldAccessToken);
      //     }
      //     if (oldAccessToken != data.token.access_token) {
      //       localStorage.removeItem("acesss");
      //       localStorage.removeItem("canvasimage");
      //     }
      //     localStorage.setItem("acesss", data.token.access_token);
      //     localStorage.setItem("refresh", data.token.refresh_token);
      //     localStorage.setItem("tokenSetTime", new Date().toISOString());

      //     if (data.token.aasm_state == "complete") {
      //       if (refnum) {
      //         navigate("/refer/" + refnum + window.location.search);
      //       } else {
      //         navigate("/refer/" + window.location.search);
      //       }
      //     } else {
      //       if (refnum) {
      //         navigate("/home/" + refnum + window.location.search);
      //       } else {
      //         navigate("/home/" + window.location.search);
      //       }
      //     }
      //   }
      // } else if (response.status == 403) {
      //   setErrorpopup(true);
      //   setMessage("Access Denied. Please try again");
      // } else {
      //   setErrorpopup(true);
      //   setMessage(data.message);
      // }
    } catch (error) {
      console.error(error);
    }
  };

  const popupclose = () => {
    setErrorpopup(false);
  };
  return (
    <>
      <section className="main_bg">
        <div className="lang_main_flex lang_main_flex_pad">
          <div className="lang_headerbg">
            <div className="member_container">
              <div className="lang_header">
                <div className="janta_part_flex">
                  <img
                    src="/assets/images/bjplogonew.png"
                    className="bjplogo"
                    alt="BJPL Logo"
                  />
                  <h6>{textMapping("Bharatiya Janata Party")}</h6>
                </div>
                <Language freshlang={setLanguval} />
              </div>
            </div>
          </div>

          <div className="member_container">
            <div>
              <img
                src="/assets/images/sadyastalogo.png"
                className="bjpsadyata_circle"
                alt="Sadyasta Logo"
              />
              {/* <img
              src="/assets/images/sadaysta.png"
              className="bjpsadyata_img"
              alt="Sadyasta Logo"
            /> */}
              <h3 className="bjpabhiyan">
                {textMapping("भाजपा सदस्यता अभियान - 2024")}
              </h3>
            </div>
            {/* <h4 className="lang_head">भाजपा सदस्यता अभियान - 2024</h4> */}

            <div className="select_lang">
              <h5>{textMapping("Enter Verification Code")}</h5>
              <div className="enter_number enter_number_otp">
                <h4>+91</h4>
                <h5>{num}</h5>
                <button className="edit_number_btn" onClick={Backnumber}>
                  <img
                    src="/assets/images/edit.svg"
                    className="bjpsadyata"
                    alt="Edit"
                  />
                </button>
              </div>
            </div>
            <div className="otp_input">
              <OtpInput
                value={otp}
                isInputNum={true}
                onChange={handleOtpChange}
                numInputs={6}
                renderInput={(props) => (
                  <input {...props} type="tel" inputMode="numeric" />
                )}
              />

              {/* <a
                className={`resendlink ${isResendEnabled ? "" : "disabled"}`}
                onClick={handleResendOtp}
                disabled={!isResendEnabled}
              > */}
              <a
                className={`resendlink ${
                  isResendEnabled && !timer ? "" : "disabled"
                }`}
                onClick={handleResendOtp}
                style={{
                  pointerEvents: isResendEnabled && !timer ? "auto" : "none",
                }} // Disables click when the button is disabled
              >
                <span>
                  <u>{textMapping("Resend Verification Code")}</u>
                </span>{" "}
                <span className="timer">{formatTime(timer)}</span>
              </a>

              {remainmessage && remainingOtp < 4 && (
                <p
                  style={{
                    textAlign: "right",
                    color: "red",
                    marginTop: "10px",
                    color: "rgba(0, 0, 0, 0.5)",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  (Remaining attempts {remainingOtp})
                </p>
              )}
            </div>
          </div>

          <div className="member_container">
            <a
              onClick={handleotp}
              // home
              className={`next_pagebtn ${
                isButtonEnabled ? "" : "next_pagebtn_disable"
              }`}
            >
              {textMapping("Continue")}
              <img
                src="/assets/images/arrownext.svg"
                className="active_arrow"
                alt="Arrow Next"
              />
              <img
                src="/assets/images/chevrondisable.svg"
                className="disable_arrow"
                alt="Chevron Disable"
              />
            </a>
          </div>
        </div>
        {errorpopup && <ErrorPopup message={message} popupclose={popupclose} />}
      </section>
    </>
  );
};

export default Otp;
